<template>
    <b-row>
        <b-col cols="12">
            <div class="text-center text-primary my-2" v-if="!component">
                <b-skeleton width="100%" height="250px" class="align-middle" animation="throb"/>
            </div>

            <div v-else>
                <PowerApp 
                    :id="getComponentID()" 
                    :nodes="component.settings.templates" 
                    v-if="isCustomTemplate"  
                    :entrypoint="templateEntrypoint" 
                    :schema="selectedSchema"
                    
                    noRouter

                    v-on="$listeners"

                    v-bind="$attrs"
                    :component="component"
                />
                <DefaultCreate :id="getComponentID()" :component="component" @modelChanged="modelChanged" @created="created" :externalModel="model" v-bind="$attrs" v-on="$listeners" v-else >
                    <template #controls="props">
                        <slot name="controls" v-bind="props"></slot>
                    </template>
                </DefaultCreate>
            </div>
        </b-col>
    </b-row>
</template>

<script>
export default {
    name: 'Create',
    components: {
        DefaultCreate: () => import('./DefaultCreate.vue'),
        PowerApp: () => import('./ComponentView')
    },
    props: {
        id: {
            type: String,
            default: null
        },
        modelUuid: {
            type: String,
            default: null
        },
        entrypoint: {
            type: String,
        },
        model: {
            type: Object
        }
    },
    data: () => {
        return {
            component: null,
            selectedSchema: ''
        }
    },
    computed: {
        isCustomTemplate() {
            return this.templateEntrypoint != ''
        },

        templateEntrypoint() {
            if (this.entrypoint == 'default') return ''
            if (this.entrypoint) return this.entrypoint

            return this.component.settings.appearance.create_entrypoint
        }
    },
    methods: {
        getBaseRef() {
            return this.id || (this.$route ? this.$route.meta.ref : null)
        },
        
        getComponentID() {
            if (this.id) {
                return this.id
            }
            
            let ref = this.$route ? this.$route.meta.ref : null
            
            // Include schema in the ref if schema is selected
            if (ref && this.component) {
                // Use base ref for storage key, not the computed ref with schema
                const baseRef = this.getBaseRef()
                const storageKey = `component_${baseRef}_schema`
                const selectedSchema = localStorage.getItem(storageKey)
                
                if (selectedSchema) {
                    ref = `${ref}.${selectedSchema}`
                }
            }
            
            return ref
        },

        modelChanged(model) {
            this.$emit('modelChanged', model)
        },

        created(model) {console.log('created in create.vue', model)
            this.$emit('created', model)
        }
    },

    updated() {
        console.log("[Render] Edit rendered")
    },

    created() {
        this.$store.dispatch("fetchComponentsSettings", this.getBaseRef()).then(data => {
            this.component = data
            
            // Initialize selected schema from localStorage
            const baseRef = this.getBaseRef()
            const storageKey = `component_${baseRef}_schema`
            const storedSchema = localStorage.getItem(storageKey)
            this.selectedSchema = storedSchema !== null ? storedSchema : ''

            if (this.$route && this.$route.meta) {
                this.$route.meta.label = this.$translateLabel(this.component.general.label)
            }
        }).catch((err) => {
            console.error(err)
            this.$bvToast.toast(this.$t('unexpectedError'), {
                variant: 'danger'
            })
        })
    },
}
</script>
